var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 13.7381L4.09222 15.885C3.62452 16.1419 3.04604 15.954 2.80016 15.4652C2.70225 15.2706 2.66846 15.0477 2.70403 14.831L3.45034 10.2838L0.288927 7.06349C-0.0894508 6.67806 -0.0971931 6.04507 0.271634 5.64966C0.418503 5.49221 0.610945 5.38974 0.819169 5.35812L5.18813 4.6947L7.14199 0.557552C7.37584 0.0623918 7.94953 -0.140909 8.42336 0.103467C8.61204 0.200779 8.76477 0.360376 8.85789 0.557552L10.8117 4.6947L15.1807 5.35812C15.7036 5.43752 16.0659 5.94487 15.9899 6.49131C15.9597 6.70891 15.8616 6.91001 15.7109 7.06349L12.5495 10.2838L13.2958 14.831C13.3852 15.3752 13.0354 15.8921 12.5146 15.9854C12.3072 16.0226 12.0939 15.9873 11.9077 15.885L7.99994 13.7381Z",
    fill: "#F9C600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.b70bde69bc88439ec37476f5f1dbb621.svg";
export { ForwardRef as ReactComponent };